// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_math = require("rescript/lib/js/js_math.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_provers = require("../mm-utils/MM_provers.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var MM_wrk_unify = require("../worker/MM_wrk_unify.bs.js");
var MM_wrk_client = require("../worker/MM_wrk_client.bs.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.bs.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.bs.js");
var MM_cmp_proof_tree = require("./MM_cmp_proof_tree.bs.js");
var MM_cmp_root_stmts = require("./MM_cmp_root_stmts.bs.js");
var MM_statements_dto = require("../mm-utils/MM_statements_dto.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Radio = require("@mui/material/Radio").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var Divider = require("@mui/material/Divider").default;
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var AutocompleteVirtualized = require("../ui-utils/AutocompleteVirtualized.bs.js");
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var Pagination = require("@mui/material/Pagination").default;
var RadioGroup = require("@mui/material/RadioGroup").default;
var FormControl = require("@mui/material/FormControl").default;
var Warning = require("@mui/icons-material/Warning").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function getProofStatus(stmt) {
  if (stmt.isHyp) {
    return /* Ready */0;
  } else {
    return stmt.proofStatus;
  }
}

function exprMayMatchAsrt(expr, frm, parenCnt) {
  if (Caml_array.get(expr, 0) !== Caml_array.get(frm.frame.asrt, 0)) {
    return false;
  }
  var res = {
    contents: false
  };
  MM_substitution.iterateSubstitutions(frm.frame.asrt, expr, Caml_array.get(frm.frmConstParts, frm.numOfHypsE), Caml_array.get(frm.constParts, frm.numOfHypsE), Caml_array.get(frm.varGroups, frm.numOfHypsE), frm.subs, parenCnt, (function (param) {
          res.contents = true;
          return /* Stop */1;
        }));
  return res.contents;
}

function getAvailableAsrtLabels(frms, parenCnt, exprToProve) {
  var availableAsrtLabels = [];
  MM_substitution.frmsForEach(frms, undefined, (function (frm) {
          if (exprMayMatchAsrt(exprToProve, frm, parenCnt)) {
            availableAsrtLabels.push(frm.frame.label);
            return ;
          }
          
        }));
  return availableAsrtLabels;
}

function makeInitialState(rootUserStmts, frms, parenCnt, initialParams, initialDebugLevel, allowedFrms) {
  var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
  var rootStmtsLen = rootStmts.length;
  var maxRootStmtIdx = rootStmtsLen - 1 | 0;
  var exprToProve = Caml_array.get(rootStmts, maxRootStmtIdx).expr;
  var possibleArgs = rootStmts.filter(function (param, i) {
          return i < maxRootStmtIdx;
        }).map(function (stmt) {
        return stmt.expr;
      });
  var params = initialParams !== undefined ? initialParams : MM_provers.bottomUpProverParamsMake(undefined, undefined, undefined, undefined, undefined, undefined, possibleArgs, undefined, undefined, undefined);
  var partial_arg = params.args0;
  var partial_arg$1 = params.args1;
  return {
          rootUserStmts: rootUserStmts,
          rootStmts: rootStmts,
          rootStmtsRendered: rootUserStmts.filter(function (param, i) {
                  return i < maxRootStmtIdx;
                }).map(function (stmt) {
                var expr = stmt.expr;
                var tmp;
                if (expr !== undefined) {
                  tmp = expr;
                } else {
                  throw {
                        RE_EXN_ID: MM_parser.MmException,
                        _1: {
                          msg: "expr must be set on a root statement."
                        },
                        Error: new Error()
                      };
                }
                return {
                        id: stmt.id,
                        expr: tmp,
                        isHyp: stmt.typ === /* E */0,
                        label: stmt.label,
                        proofStatus: stmt.proofStatus,
                        exprReElem: React.createElement("span", undefined, MM_cmp_user_stmt.rndContText(stmt.cont, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))
                      };
              }),
          exprToProve: exprToProve,
          title: React.createElement("span", undefined, React.createElement("span", {
                    style: {
                      fontWeight: "bold"
                    }
                  }, "Proving bottom-up "), MM_cmp_user_stmt.rndContText(Caml_array.get(rootUserStmts, maxRootStmtIdx).cont, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)),
          args0: possibleArgs.map(function (param) {
                return partial_arg.includes(param);
              }),
          args1: possibleArgs.map(function (param) {
                return partial_arg$1.includes(param);
              }),
          availableLabels: getAvailableAsrtLabels(frms, parenCnt, exprToProve),
          label: params.asrtLabel,
          depth: params.maxSearchDepth,
          depthStr: String(params.maxSearchDepth),
          lengthRestrict: params.lengthRestrict,
          allowNewDisjForExistingVars: params.allowNewDisjForExistingVars,
          allowNewStmts: params.allowNewStmts,
          allowNewVars: params.allowNewVars,
          useDisc: allowedFrms.inEssen.useDisc,
          useDepr: allowedFrms.inEssen.useDepr,
          useTranDepr: allowedFrms.inEssen.useTranDepr,
          debugLevel: Belt_Option.getWithDefault(Belt_Option.map(initialDebugLevel, (function (lvl) {
                      if (0 <= lvl && lvl <= 2) {
                        return lvl;
                      } else {
                        return 0;
                      }
                    })), 0),
          maxNumberOfBranchesStr: Belt_Option.getWithDefault(Belt_Option.map(params.maxNumberOfBranches, (function (prim) {
                      return String(prim);
                    })), ""),
          tree: undefined,
          warnings: [],
          results: undefined,
          resultsRendered: undefined,
          sortBy: /* UnprovedStmtsNum */0,
          resultsSorted: undefined,
          resultsPerPage: 20,
          resultsMaxPage: 0,
          resultsPage: 0,
          checkedResultIdx: undefined
        };
}

function setLabel(st, label) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.label = label;
  return newrecord;
}

function setDepthStr(st, depthStr) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.depthStr = depthStr;
  return newrecord;
}

function setLengthRestrict(st, lengthRestrict) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.lengthRestrict = lengthRestrict;
  return newrecord;
}

function toggleAllowNewDisjForExistingVars(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.allowNewDisjForExistingVars = !st.allowNewDisjForExistingVars;
  return newrecord;
}

function toggleAllowNewStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.allowNewStmts = !st.allowNewStmts;
  return newrecord;
}

function toggleAllowNewVars(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.allowNewVars = !st.allowNewVars;
  return newrecord;
}

function toggleUseDisc(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.useDisc = !st.useDisc;
  return newrecord;
}

function toggleUseDepr(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.useDepr = !st.useDepr;
  return newrecord;
}

function toggleUseTranDepr(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.useTranDepr = !st.useTranDepr;
  return newrecord;
}

function setDebugLevel(st, debugLevel) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.debugLevel = 0 <= debugLevel && debugLevel <= 2 ? debugLevel : 0;
  return newrecord;
}

var nonDigitPattern = /\D/g;

function setMaxNumberOfBranchesStr(st, maxNumberOfBranchesStr) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.maxNumberOfBranchesStr = maxNumberOfBranchesStr.replace(nonDigitPattern, "");
  return newrecord;
}

function selectAllArgs(args) {
  return args.map(function (param) {
              return true;
            });
}

function unselectAllArgs(args) {
  return args.map(function (param) {
              return false;
            });
}

function updateArgs0(st, args0) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.args0 = args0;
  return newrecord;
}

function updateArgs1(st, args1) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.args1 = args1;
  return newrecord;
}

function isStmtToShow(stmt, rootJstfs) {
  var match = Belt_HashMap.get(rootJstfs, stmt.expr);
  if (match === undefined) {
    return true;
  }
  var rootJstf = Caml_option.valFromOption(match);
  if (rootJstf === undefined) {
    return Belt_Option.isSome(stmt.jstf);
  }
  var foundJstf = stmt.jstf;
  if (foundJstf !== undefined) {
    return !MM_statements_dto.jstfEq(rootJstf, foundJstf);
  } else {
    return false;
  }
}

function stmtsDtoToResultRendered(stmtsDto, idx, isStmtToShow, getFrmLabelBkgColor) {
  var maxI = stmtsDto.stmts.length - 1 | 0;
  var stmtsToShow = stmtsDto.stmts.filter(function (stmt, i) {
        if (i === maxI) {
          return true;
        } else {
          return Curry._1(isStmtToShow, stmt);
        }
      });
  var elem = React.createElement(Expln_React_Column.make, {
        children: Caml_option.some(null)
      }, stmtsDto.newDisjStr.map(function (disjStr) {
            return React.createElement("span", {
                        key: disjStr
                      }, disjStr);
          }), React.createElement("table", undefined, React.createElement("tbody", undefined, stmtsToShow.map(function (stmt) {
                    var match = stmt.jstf;
                    var tmp;
                    if (match !== undefined) {
                      var label = match.label;
                      var tmp$1 = {
                        borderRadius: "3px"
                      };
                      var tmp$2 = Curry._1(getFrmLabelBkgColor, label);
                      if (tmp$2 !== undefined) {
                        tmp$1.backgroundColor = tmp$2;
                      }
                      tmp = React.createElement(React.Fragment, undefined, React.createElement("span", undefined, "[" + match.args.join(" ") + " : "), React.createElement("span", {
                                style: tmp$1
                              }, label), React.createElement("span", undefined, " ]"));
                    } else {
                      tmp = null;
                    }
                    return React.createElement("tr", {
                                key: stmt.exprStr
                              }, React.createElement("td", undefined, stmt.label), React.createElement("td", {
                                    style: {
                                      textAlign: "right"
                                    }
                                  }, React.createElement("nobr", undefined, tmp)), React.createElement("td", {
                                    style: {
                                      color: stmt.isProved ? "green" : "#565656",
                                      fontWeight: "bold"
                                    }
                                  }, stmt.isProved ? "\u2713" : "?"), React.createElement("td", undefined, stmt.exprStr));
                  }))));
  var lastStmt = Caml_array.get(stmtsDto.stmts, stmtsDto.stmts.length - 1 | 0);
  return {
          idx: idx,
          elem: elem,
          isProved: lastStmt.isProved,
          asrtLabel: Belt_Option.getWithDefault(Belt_Option.map(lastStmt.jstf, (function (jstf) {
                      return jstf.label;
                    })), ""),
          numOfNewVars: stmtsDto.newVars.length,
          numOfUnprovedStmts: stmtsDto.stmts.reduce((function (cnt, stmt) {
                  return cnt + (
                          stmt.isProved ? 0 : 1
                        ) | 0;
                }), 0),
          numOfStmts: stmtsToShow.length
        };
}

function compareByIsProved(param, param$1) {
  return Expln_utils_common.comparatorBy((function (res) {
                if (res.isProved) {
                  return 0;
                } else {
                  return 1;
                }
              }), param, param$1);
}

function compareByNumberOfStmts(param, param$1) {
  return Expln_utils_common.comparatorBy((function (res) {
                return res.numOfStmts;
              }), param, param$1);
}

function compareByNumOfUnprovedStmts(param, param$1) {
  return Expln_utils_common.comparatorBy((function (res) {
                return res.numOfUnprovedStmts;
              }), param, param$1);
}

function compareByNumOfNewVars(param, param$1) {
  return Expln_utils_common.comparatorBy((function (res) {
                return res.numOfNewVars;
              }), param, param$1);
}

function compareByAsrtLabel(a, b) {
  return a.asrtLabel.localeCompare(b.asrtLabel) | 0;
}

function createComparator(sortBy) {
  var mainCmp;
  switch (sortBy) {
    case /* UnprovedStmtsNum */0 :
        mainCmp = compareByNumOfUnprovedStmts;
        break;
    case /* NumOfNewVars */1 :
        mainCmp = compareByNumOfNewVars;
        break;
    case /* AsrtLabel */2 :
        mainCmp = compareByAsrtLabel;
        break;
    
  }
  return function (param, param$1) {
    return Expln_utils_common.comparatorAndThen((function (param, param$1) {
                  return Expln_utils_common.comparatorAndThen((function (param, param$1) {
                                return Expln_utils_common.comparatorAndThen(compareByIsProved, mainCmp, param, param$1);
                              }), compareByNumberOfStmts, param, param$1);
                }), compareByAsrtLabel, param, param$1);
  };
}

function sortResultsRendered(resultsRendered, sortBy) {
  return Belt_Option.map(resultsRendered, (function (resultsRendered) {
                return resultsRendered.slice().sort(createComparator(sortBy));
              }));
}

function isTruncatedSearchErr(src) {
  if (typeof src === "number") {
    return false;
  }
  if (src.TAG !== /* AssertionWithErr */2) {
    return false;
  }
  var tmp = src.err;
  if (typeof tmp === "number" || tmp.TAG !== /* TooManyCombinations */6) {
    return false;
  } else {
    return true;
  }
}

function findWarnings(tree) {
  if (tree.nodes.some(function (n) {
          return n.parents.some(isTruncatedSearchErr);
        })) {
    return ["The search space was truncated due to some assertions produce too big search space. Use Logging level = 1 and then click 'Show Proof Tree' button to find those assertions."];
  } else {
    return [];
  }
}

function setResults(st, tree, warnings, results, getFrmLabelBkgColor) {
  if (results !== undefined) {
    var rootJstfs = Belt_HashMap.fromArray(st.rootStmts.map(function (stmt) {
              return [
                      stmt.expr,
                      stmt.jstf
                    ];
            }), MM_context.ExprHash);
    var isStmtToShow$1 = function (stmt) {
      return isStmtToShow(stmt, rootJstfs);
    };
    var resultsRendered = results.map(function (dto, i) {
          return stmtsDtoToResultRendered(dto, i, isStmtToShow$1, getFrmLabelBkgColor);
        });
    var newrecord = Caml_obj.obj_dup(st);
    newrecord.checkedResultIdx = undefined;
    newrecord.resultsPage = 1;
    newrecord.resultsMaxPage = Js_math.ceil_int(results.length / st.resultsPerPage);
    newrecord.resultsSorted = sortResultsRendered(resultsRendered, st.sortBy);
    newrecord.resultsRendered = resultsRendered;
    newrecord.results = results;
    newrecord.warnings = warnings;
    newrecord.tree = tree;
    return newrecord;
  }
  var newrecord$1 = Caml_obj.obj_dup(st);
  newrecord$1.checkedResultIdx = undefined;
  newrecord$1.resultsPage = 0;
  newrecord$1.resultsMaxPage = 0;
  newrecord$1.resultsSorted = undefined;
  newrecord$1.resultsRendered = undefined;
  newrecord$1.results = results;
  newrecord$1.warnings = warnings;
  newrecord$1.tree = undefined;
  return newrecord$1;
}

function setSortBy(st, sortBy) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedResultIdx = undefined;
  newrecord.resultsPage = 1;
  newrecord.resultsSorted = sortResultsRendered(st.resultsRendered, sortBy);
  newrecord.sortBy = sortBy;
  return newrecord;
}

function setPage(st, page) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.resultsPage = page;
  return newrecord;
}

function toggleResultChecked(st, idx) {
  var checkedIdx = st.checkedResultIdx;
  if (checkedIdx !== undefined) {
    if (checkedIdx !== idx) {
      var newrecord = Caml_obj.obj_dup(st);
      newrecord.checkedResultIdx = idx;
      return newrecord;
    }
    var newrecord$1 = Caml_obj.obj_dup(st);
    newrecord$1.checkedResultIdx = undefined;
    return newrecord$1;
  }
  var newrecord$2 = Caml_obj.obj_dup(st);
  newrecord$2.checkedResultIdx = idx;
  return newrecord$2;
}

function lengthRestrictToStr(len) {
  switch (len) {
    case /* No */0 :
        return "No";
    case /* LessEq */1 :
        return "LessEq";
    case /* Less */2 :
        return "Less";
    
  }
}

function lengthRestrictFromStr(str) {
  switch (str) {
    case "Less" :
        return /* Less */2;
    case "LessEq" :
        return /* LessEq */1;
    case "No" :
        return /* No */0;
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert '" + str + "' to lengthRestrict."
            },
            Error: new Error()
          };
  }
}

function sortByToStr(sortBy) {
  switch (sortBy) {
    case /* UnprovedStmtsNum */0 :
        return "UnprovedStmtsNum";
    case /* NumOfNewVars */1 :
        return "NumOfNewVars";
    case /* AsrtLabel */2 :
        return "AsrtLabel";
    
  }
}

function sortByFromStr(str) {
  switch (str) {
    case "AsrtLabel" :
        return /* AsrtLabel */2;
    case "NumOfNewVars" :
        return /* NumOfNewVars */1;
    case "UnprovedStmtsNum" :
        return /* UnprovedStmtsNum */0;
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert value of '" + str + "' to a sortBy."
            },
            Error: new Error()
          };
  }
}

function rndCheckboxWithLabelAndBorder(checked, onChange, label) {
  return React.createElement(FormControlLabel, {
              control: React.createElement(Checkbox, {
                    checked: checked,
                    onChange: (function (param) {
                        return Expln_React_common.evt2bool(onChange, param);
                      })
                  }),
              label: label,
              style: {
                border: "solid 1px lightgrey",
                paddingRight: "10px",
                borderRadius: "7px"
              }
            });
}

function MM_cmp_unify_bottom_up(props) {
  var onCancel = props.onCancel;
  var onResultSelected = props.onResultSelected;
  var initialDebugLevel = props.initialDebugLevel;
  var initialParams = props.initialParams;
  var typeToPrefix = props.typeToPrefix;
  var reservedLabels = props.reservedLabels;
  var rootStmts = props.rootStmts;
  var wrkCtx = props.wrkCtx;
  var disjText = props.disjText;
  var varsText = props.varsText;
  var parenCnt = props.parenCnt;
  var frms = props.frms;
  var preCtx = props.preCtx;
  var preCtxVer = props.preCtxVer;
  var settings = props.settings;
  var settingsVer = props.settingsVer;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        return makeInitialState(rootStmts, frms, parenCnt, initialParams, initialDebugLevel, settings.allowedFrms);
      });
  var setState = match[1];
  var state = match[0];
  var results = state.results;
  var onlyOneResultIsAvailable = results !== undefined ? results.length === 1 : false;
  var actLabelUpdated = function (label) {
    Curry._1(setState, (function (__x) {
            return setLabel(__x, label);
          }));
  };
  var actDepthUpdated = function (depthStr) {
    Curry._1(setState, (function (__x) {
            return setDepthStr(__x, depthStr.replace(nonDigitPattern, ""));
          }));
  };
  var makeActTerminate = function (modalId, param) {
    MM_wrk_client.terminateWorker(undefined);
    Expln_React_Modal.closeModal(modalRef, modalId);
  };
  var getFrmLabelBkgColor = function (label) {
    var frm = MM_substitution.frmsGetByLabel(frms, label);
    if (frm !== undefined) {
      return MM_react_common.getFrmLabelBkgColor(frm.frame, settings);
    }
    
  };
  var actProve = function (param) {
    Curry._1(setState, (function (st) {
            var depthStr = st.depthStr.trim();
            var st$1;
            if (depthStr.length === 0) {
              var newrecord = Caml_obj.obj_dup(st);
              newrecord.depthStr = "1";
              newrecord.depth = 1;
              st$1 = newrecord;
            } else {
              var depth = Math.max(Belt_Option.getWithDefault(Belt_Int.fromString(depthStr), 1), 1);
              var depthStr$1 = String(depth);
              var newrecord$1 = Caml_obj.obj_dup(st);
              newrecord$1.depthStr = depthStr$1;
              newrecord$1.depth = depth;
              st$1 = newrecord$1;
            }
            Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                        return MM_react_common.rndProgress("Proving bottom-up", 0, undefined, undefined);
                      })), (function (modalId) {
                    Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                            return MM_react_common.rndProgress("Proving bottom-up", 0, (function (param) {
                                          return makeActTerminate(modalId, param);
                                        }), undefined);
                          }));
                    return Expln_utils_promise.promiseMap(MM_wrk_unify.unify(settingsVer, settings, preCtxVer, preCtx, varsText, disjText, state.rootStmts, {
                                    asrtLabel: st$1.label,
                                    maxSearchDepth: st$1.depth,
                                    lengthRestrict: st$1.lengthRestrict,
                                    allowNewDisjForExistingVars: st$1.allowNewDisjForExistingVars,
                                    allowNewStmts: st$1.allowNewStmts,
                                    allowNewVars: st$1.allowNewVars,
                                    args0: st$1.rootStmtsRendered.filter(function (param, i) {
                                            return Caml_array.get(st$1.args0, i);
                                          }).map(function (stmt) {
                                          return stmt.expr;
                                        }),
                                    args1: st$1.rootStmtsRendered.filter(function (param, i) {
                                            return Caml_array.get(st$1.args1, i);
                                          }).map(function (stmt) {
                                          return stmt.expr;
                                        }),
                                    maxNumberOfBranches: state.debugLevel === 0 || state.maxNumberOfBranchesStr === "" ? undefined : Belt_Int.fromString(state.maxNumberOfBranchesStr)
                                  }, {
                                    inSyntax: settings.allowedFrms.inSyntax,
                                    inEssen: {
                                      useDisc: state.useDisc,
                                      useDepr: state.useDepr,
                                      useTranDepr: state.useTranDepr
                                    }
                                  }, undefined, undefined, st$1.debugLevel, (function (msg) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return MM_react_common.rndProgress(msg, undefined, (function (param) {
                                                            return makeActTerminate(modalId, param);
                                                          }), undefined);
                                            }));
                                    })), (function (proofTreeDto) {
                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                  var rootExprToLabel = Belt_HashMap.fromArray(state.rootStmts.map(function (stmt) {
                                            return [
                                                    stmt.expr,
                                                    stmt.label
                                                  ];
                                          }), MM_context.ExprHash);
                                  var results = MM_wrk_unify.proofTreeDtoToNewStmtsDto(proofTreeDto, state.exprToProve, wrkCtx, typeToPrefix, rootExprToLabel, reservedLabels);
                                  Curry._1(setState, (function (st) {
                                          return setResults(st, st.debugLevel > 0 ? proofTreeDto : undefined, findWarnings(proofTreeDto), results, getFrmLabelBkgColor);
                                        }));
                                }));
                  }));
            return st$1;
          }));
  };
  var actMaxNumberOfBranchesStrUpdated = function (maxNumberOfBranchesStr) {
    Curry._1(setState, (function (__x) {
            return setMaxNumberOfBranchesStr(__x, maxNumberOfBranchesStr);
          }));
  };
  var rndLengthRestrictSelector = function (value) {
    return React.createElement(FormControl, {
                size: "small",
                children: Caml_option.some(null)
              }, React.createElement(InputLabel, {
                    id: "length-restrict-select-label",
                    children: "Statement length restriction"
                  }), React.createElement(Select, {
                    sx: {
                      width: 190
                    },
                    labelId: "length-restrict-select-label",
                    label: "Statement length restriction",
                    value: lengthRestrictToStr(value),
                    onChange: (function (param) {
                        return Expln_React_common.evt2str((function (str) {
                                      var lengthRestrict = lengthRestrictFromStr(str);
                                      Curry._1(setState, (function (__x) {
                                              return setLengthRestrict(__x, lengthRestrict);
                                            }));
                                    }), param);
                      }),
                    children: Caml_option.some(null)
                  }, React.createElement(MenuItem, {
                        value: "No",
                        children: "Unrestricted"
                      }), React.createElement(MenuItem, {
                        value: "LessEq",
                        children: "LessEq"
                      }), React.createElement(MenuItem, {
                        value: "Less",
                        children: "Less"
                      })));
  };
  var rndSortBySelector = function (param) {
    var results = state.results;
    if (results !== undefined && results.length >= 2) {
      return React.createElement(FormControl, {
                  size: "small",
                  children: Caml_option.some(null)
                }, React.createElement(InputLabel, {
                      id: "sortBy-select-label",
                      children: "Sort results by"
                    }), React.createElement(Select, {
                      labelId: "sortBy-select-label",
                      label: "Sort results by",
                      value: sortByToStr(state.sortBy),
                      onChange: (function (param) {
                          return Expln_React_common.evt2str((function (str) {
                                        var sortBy = sortByFromStr(str);
                                        Curry._1(setState, (function (__x) {
                                                return setSortBy(__x, sortBy);
                                              }));
                                      }), param);
                        }),
                      children: Caml_option.some(null)
                    }, React.createElement(MenuItem, {
                          value: "UnprovedStmtsNum",
                          children: "Number of unproved steps"
                        }), React.createElement(MenuItem, {
                          value: "NumOfNewVars",
                          children: "Number of new variables"
                        }), React.createElement(MenuItem, {
                          value: "AsrtLabel",
                          children: "Assertion label"
                        })));
    } else {
      return null;
    }
  };
  var rndDebugParam = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "center",
                children: Caml_option.some(null)
              }, "Logging level", React.createElement(RadioGroup, {
                    value: String(state.debugLevel),
                    onChange: (function (param) {
                        return Expln_React_common.evt2str((function (str) {
                                      var debugLevel = Belt_Option.getExn(Belt_Int.fromString(str));
                                      Curry._1(setState, (function (__x) {
                                              return setDebugLevel(__x, debugLevel);
                                            }));
                                    }), param);
                      }),
                    row: true,
                    children: Caml_option.some(null)
                  }, React.createElement(FormControlLabel, {
                        control: React.createElement(Radio, {}),
                        label: "0",
                        value: "0"
                      }), React.createElement(FormControlLabel, {
                        control: React.createElement(Radio, {}),
                        label: "1",
                        value: "1"
                      }), React.createElement(FormControlLabel, {
                        control: React.createElement(Radio, {}),
                        label: "2",
                        value: "2"
                      })));
  };
  var rndParams = function (param) {
    if (state.availableLabels.length === 0) {
      return React.createElement(Expln_React_Column.make, {
                  children: Caml_option.some(null)
                }, "The statement to prove doesn't match any existing assertion. Bottom-up proving is not available for such statements.", React.createElement(Button, {
                      onClick: (function (param) {
                          Curry._1(onCancel, undefined);
                        }),
                      children: "Ok"
                    }));
    }
    var partial_arg = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onCancel, undefined);
    var partial_arg$1 = MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actProve, undefined);
    var partial_arg$2 = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onCancel, undefined);
    var partial_arg$3 = MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actProve, undefined);
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, React.createElement(Expln_React_Row.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(AutocompleteVirtualized.make, {
                        value: state.label,
                        options: state.availableLabels,
                        onChange: actLabelUpdated,
                        size: "small",
                        width: 200,
                        label: "Label of root justification"
                      }), React.createElement(TextField, {
                        value: state.depthStr,
                        label: "Search depth",
                        size: "small",
                        style: {
                          width: "100px"
                        },
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actDepthUpdated, param);
                          }),
                        onKeyDown: (function (param) {
                            return MM_react_common.kbrdHnd2(partial_arg$1, partial_arg, param);
                          }),
                        autoFocus: true
                      }), rndLengthRestrictSelector(state.lengthRestrict)), React.createElement(Expln_React_Row.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(FormControlLabel, {
                        control: React.createElement(Checkbox, {
                              checked: state.allowNewDisjForExistingVars,
                              onChange: (function (param) {
                                  Curry._1(setState, toggleAllowNewDisjForExistingVars);
                                })
                            }),
                        label: "Allow new disjoints",
                        style: {
                          border: "solid 1px lightgrey",
                          marginTop: "-2px",
                          marginLeft: "2px",
                          paddingRight: "10px",
                          borderRadius: "7px"
                        }
                      }), React.createElement(FormControlLabel, {
                        control: React.createElement(Checkbox, {
                              checked: state.allowNewStmts,
                              onChange: (function (param) {
                                  Curry._1(setState, toggleAllowNewStmts);
                                })
                            }),
                        label: "Allow new steps",
                        style: {
                          border: "solid 1px lightgrey",
                          marginTop: "-2px",
                          marginLeft: "2px",
                          paddingRight: "10px",
                          borderRadius: "7px"
                        }
                      }), React.createElement(FormControlLabel, {
                        control: React.createElement(Checkbox, {
                              checked: state.allowNewVars,
                              onChange: (function (param) {
                                  Curry._1(setState, toggleAllowNewVars);
                                })
                            }),
                        label: "Allow new variables",
                        disabled: !state.allowNewStmts,
                        style: {
                          border: "solid 1px lightgrey",
                          marginTop: "-2px",
                          paddingRight: "10px",
                          borderRadius: "7px"
                        }
                      })), React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, "Allow usage of assertions:"), React.createElement("td", {
                                style: {
                                  paddingLeft: "10px"
                                }
                              }, rndCheckboxWithLabelAndBorder(state.useDisc, (function (param) {
                                      Curry._1(setState, toggleUseDisc);
                                    }), "discouraged")), React.createElement("td", undefined, rndCheckboxWithLabelAndBorder(state.useDepr, (function (param) {
                                      Curry._1(setState, toggleUseDepr);
                                    }), "deprecated")), React.createElement("td", undefined, rndCheckboxWithLabelAndBorder(state.useTranDepr, (function (param) {
                                      Curry._1(setState, toggleUseTranDepr);
                                    }), "transitively deprecated"))))), React.createElement(Expln_React_Row.make, {
                    children: Caml_option.some(null)
                  }, rndDebugParam(undefined), React.createElement(TextField, {
                        value: state.maxNumberOfBranchesStr,
                        label: "Max num of branches",
                        size: "small",
                        style: {
                          width: "200px"
                        },
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actMaxNumberOfBranchesStrUpdated, param);
                          }),
                        onKeyDown: (function (param) {
                            return MM_react_common.kbrdHnd2(partial_arg$3, partial_arg$2, param);
                          }),
                        disabled: state.debugLevel === 0
                      })), React.createElement(Expln_React_Row.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(Button, {
                        onClick: (function (param) {
                            actProve(undefined);
                          }),
                        variant: "contained",
                        color: "grey",
                        children: "Prove"
                      }), React.createElement(Button, {
                        onClick: (function (param) {
                            Curry._1(onCancel, undefined);
                          }),
                        children: "Cancel"
                      })));
  };
  var rndPagination = function (totalNumOfResults) {
    if (state.resultsPerPage < totalNumOfResults) {
      return React.createElement(Pagination, {
                  count: state.resultsMaxPage,
                  page: state.resultsPage,
                  onChange: (function (param, newPage) {
                      Curry._1(setState, (function (__x) {
                              return setPage(__x, newPage);
                            }));
                    })
                });
    } else {
      return null;
    }
  };
  var rndApplyButton = function (param) {
    return React.createElement(Button, {
                onClick: (function (param) {
                    var results = state.results;
                    if (results === undefined) {
                      return ;
                    }
                    if (onlyOneResultIsAvailable) {
                      return Curry._1(onResultSelected, Caml_array.get(results, 0));
                    }
                    var checkedResultIdx = state.checkedResultIdx;
                    if (checkedResultIdx !== undefined) {
                      return Curry._1(onResultSelected, Caml_array.get(results, checkedResultIdx));
                    }
                    
                  }),
                variant: "contained",
                disabled: !onlyOneResultIsAvailable && Belt_Option.isNone(state.checkedResultIdx),
                children: Caml_option.some(onlyOneResultIsAvailable ? "Apply" : "Apply selected")
              });
  };
  var rndShowProofTreeBtn = function (param) {
    var match = state.tree;
    if (match !== undefined) {
      return React.createElement(Button, {
                  onClick: (function (param) {
                      var tree = state.tree;
                      if (tree !== undefined) {
                        Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                    return null;
                                  })), (function (modalId) {
                                Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                        var closeBtn = React.createElement(Button, {
                                              onClick: (function (param) {
                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                }),
                                              variant: "outlined",
                                              children: "Close"
                                            });
                                        return React.createElement(Expln_React_Column.make, {
                                                    spacing: 1,
                                                    style: {
                                                      margin: "5px"
                                                    },
                                                    children: Caml_option.some(null)
                                                  }, closeBtn, React.createElement(MM_cmp_proof_tree.make, {
                                                        tree: tree,
                                                        rootExpr: state.exprToProve,
                                                        settings: settings,
                                                        wrkCtx: wrkCtx,
                                                        rootStmts: state.rootStmts
                                                      }), closeBtn);
                                      }));
                              }));
                        return ;
                      }
                      
                    }),
                  variant: "outlined",
                  children: "Show proof tree"
                });
    } else {
      return null;
    }
  };
  var rndWarningsBtn = function (warnings) {
    if (warnings.length === 0) {
      return null;
    } else {
      return React.createElement(IconButton, {
                  onClick: (function (param) {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                      return React.createElement(Paper, {
                                                  style: {
                                                    padding: "10px"
                                                  },
                                                  children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                                            children: Caml_option.some(null)
                                                          }, React.createElement("ol", undefined, warnings.map(function (msg, i) {
                                                                    return React.createElement("li", {
                                                                                key: String(i)
                                                                              }, msg);
                                                                  })), React.createElement(Button, {
                                                                onClick: (function (param) {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                  }),
                                                                variant: "contained",
                                                                children: "Close"
                                                              })))
                                                });
                                    }));
                            }));
                    }),
                  color: "yellow",
                  title: "There are warnings, click to see details",
                  children: Caml_option.some(React.createElement(Warning, {}))
                });
    }
  };
  var rndResults = function (param) {
    var resultsSorted = state.resultsSorted;
    if (resultsSorted === undefined) {
      return null;
    }
    var totalNumOfResults = resultsSorted.length;
    if (totalNumOfResults === 0) {
      return React.createElement(Expln_React_Column.make, {
                  children: Caml_option.some(null)
                }, React.createElement(Divider, {}), React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, "Nothing found.", rndShowProofTreeBtn(undefined), rndWarningsBtn(state.warnings)));
    }
    var start = Math.imul(state.resultsPage - 1 | 0, state.resultsPerPage);
    var items = resultsSorted.slice(start, start + state.resultsPerPage | 0);
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, React.createElement(Divider, {}), React.createElement(Expln_React_Row.make, {
                    alignItems: "center",
                    children: Caml_option.some(null)
                  }, rndApplyButton(undefined), rndSortBySelector(undefined), rndPagination(totalNumOfResults), rndShowProofTreeBtn(undefined), rndWarningsBtn(state.warnings)), items.map(function (item) {
                    return React.createElement("table", {
                                key: String(item.idx)
                              }, React.createElement("tbody", undefined, React.createElement("tr", undefined, onlyOneResultIsAvailable ? null : React.createElement("td", undefined, React.createElement(Checkbox, {
                                                  checked: Belt_Option.getWithDefault(Belt_Option.map(state.checkedResultIdx, (function (idx) {
                                                              return idx === item.idx;
                                                            })), false),
                                                  onChange: (function (param) {
                                                      var idx = item.idx;
                                                      Curry._1(setState, (function (__x) {
                                                              return toggleResultChecked(__x, idx);
                                                            }));
                                                    })
                                                })), React.createElement("td", undefined, React.createElement(Paper, {
                                                children: Caml_option.some(item.elem)
                                              })))));
                  }), rndPagination(totalNumOfResults), rndApplyButton(undefined));
  };
  var rndRootStmtsForLevelShort = function (title, dialogTitle, getFlags, setFlags) {
    var flags = Curry._1(getFlags, state);
    var allSelected = flags.every(function (b) {
          return b;
        });
    var noneSelected = flags.every(function (b) {
          return !b;
        });
    var numberOfSelected;
    if (allSelected) {
      numberOfSelected = "All";
    } else if (noneSelected) {
      numberOfSelected = "None";
    } else {
      var numSelected = flags.reduce((function (cnt, b) {
              if (b) {
                return cnt + 1 | 0;
              } else {
                return cnt;
              }
            }), 0);
      var numAll = flags.length;
      numberOfSelected = String(numSelected) + "/" + String(numAll);
    }
    var match = noneSelected ? [
        "select all",
        (function (param) {
            Curry._1(setFlags, flags.map(function (param) {
                      return true;
                    }));
          })
      ] : [
        "select none",
        (function (param) {
            Curry._1(setFlags, flags.map(function (param) {
                      return false;
                    }));
          })
      ];
    var selectUnselectAct = match[1];
    return React.createElement(Expln_React_Row.make, {
                style: {
                  border: "solid lightgrey 1px",
                  margin: "2px",
                  borderRadius: "6px"
                },
                children: Caml_option.some(null)
              }, title, React.createElement("span", {
                    style: {
                      color: "blue",
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        var proofStatusesAreAvailable = state.rootStmtsRendered.every(function (stmt) {
                              return Belt_Option.isSome(getProofStatus(stmt));
                            });
                        Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                    return null;
                                  })), (function (modalId) {
                                Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                        return React.createElement(MM_cmp_root_stmts.make, {
                                                    title: dialogTitle,
                                                    rootStmtsRendered: state.rootStmtsRendered,
                                                    proofStatusesAreAvailable: proofStatusesAreAvailable,
                                                    flags: Curry._1(getFlags, state),
                                                    onClose: (function (newFlags) {
                                                        Curry._1(setFlags, newFlags);
                                                        Expln_React_Modal.closeModal(modalRef, modalId);
                                                      })
                                                  });
                                      }));
                              }));
                      })
                  }, numberOfSelected), React.createElement("span", {
                    style: {
                      backgroundColor: "rgb(240, 240, 240)",
                      border: "solid lightgrey 0px",
                      cursor: "pointer",
                      paddingRight: "5px",
                      paddingLeft: "5px",
                      borderRadius: "10px"
                    },
                    onClick: (function (param) {
                        Curry._1(selectUnselectAct, undefined);
                      })
                  }, match[0]));
  };
  var rndRootStmts = function (param) {
    if (state.rootStmtsRendered.length === 0) {
      return null;
    } else {
      return React.createElement(Expln_React_Row.make, {
                  alignItems: "center",
                  children: Caml_option.some(null)
                }, "Allowed statements: ", rndRootStmtsForLevelShort("first level", "Select steps to derive from on level 0", (function (state) {
                        return state.args0;
                      }), (function (newFlags) {
                        Curry._1(setState, (function (__x) {
                                return updateArgs0(__x, newFlags);
                              }));
                      })), rndRootStmtsForLevelShort("other levels", "Select steps to derive from on other levels", (function (state) {
                        return state.args1;
                      }), (function (newFlags) {
                        Curry._1(setState, (function (__x) {
                                return updateArgs1(__x, newFlags);
                              }));
                      })));
    }
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1.5,
                        children: Caml_option.some(null)
                      }, state.title, rndRootStmts(undefined), rndParams(undefined), rndResults(undefined)))
            });
}

var make = MM_cmp_unify_bottom_up;

exports.getProofStatus = getProofStatus;
exports.exprMayMatchAsrt = exprMayMatchAsrt;
exports.getAvailableAsrtLabels = getAvailableAsrtLabels;
exports.makeInitialState = makeInitialState;
exports.setLabel = setLabel;
exports.setDepthStr = setDepthStr;
exports.setLengthRestrict = setLengthRestrict;
exports.toggleAllowNewDisjForExistingVars = toggleAllowNewDisjForExistingVars;
exports.toggleAllowNewStmts = toggleAllowNewStmts;
exports.toggleAllowNewVars = toggleAllowNewVars;
exports.toggleUseDisc = toggleUseDisc;
exports.toggleUseDepr = toggleUseDepr;
exports.toggleUseTranDepr = toggleUseTranDepr;
exports.setDebugLevel = setDebugLevel;
exports.nonDigitPattern = nonDigitPattern;
exports.setMaxNumberOfBranchesStr = setMaxNumberOfBranchesStr;
exports.selectAllArgs = selectAllArgs;
exports.unselectAllArgs = unselectAllArgs;
exports.updateArgs0 = updateArgs0;
exports.updateArgs1 = updateArgs1;
exports.isStmtToShow = isStmtToShow;
exports.stmtsDtoToResultRendered = stmtsDtoToResultRendered;
exports.compareByIsProved = compareByIsProved;
exports.compareByNumberOfStmts = compareByNumberOfStmts;
exports.compareByNumOfUnprovedStmts = compareByNumOfUnprovedStmts;
exports.compareByNumOfNewVars = compareByNumOfNewVars;
exports.compareByAsrtLabel = compareByAsrtLabel;
exports.createComparator = createComparator;
exports.sortResultsRendered = sortResultsRendered;
exports.isTruncatedSearchErr = isTruncatedSearchErr;
exports.findWarnings = findWarnings;
exports.setResults = setResults;
exports.setSortBy = setSortBy;
exports.setPage = setPage;
exports.toggleResultChecked = toggleResultChecked;
exports.lengthRestrictToStr = lengthRestrictToStr;
exports.lengthRestrictFromStr = lengthRestrictFromStr;
exports.sortByToStr = sortByToStr;
exports.sortByFromStr = sortByFromStr;
exports.rndCheckboxWithLabelAndBorder = rndCheckboxWithLabelAndBorder;
exports.make = make;
/* react Not a pure module */
